import MergeCustomersModalReducer from "@common/redux/reducers/MergeCustomersModalReducer";
import BaseAction from "./BaseAction";

class MergeCustomersModalAction extends BaseAction {
  onClose = () => {};

  open = (primaryCustomer, options = {}) => {
    this.dispatch({ open: true, primaryCustomer, onMergeComplete: options.onMergeComplete });
  };

  close = () => {
    this.dispatch({ open: false, primaryCustomer: null, onMergeComplete: null });
  };
}

const action = new MergeCustomersModalAction(MergeCustomersModalReducer);

export default action;
